import React, {useContext} from 'react';

import {ListContext} from "components/List/context/ListContext";
import FormikInput from "components/input/new/FormikInput";

function SyliusCodeField(props) {
    const {selectedItem} = useContext(ListContext);

    return (
        <FormikInput
            type={'string'}
            name={'shopName'}
            label={'shippingMethods.form.field.shopName.label'}
            placeholder={'shippingMethods.form.field.shopName.placeholder'}
            required={true}
            disabled={selectedItem !== null}
        />
    );
}

export default SyliusCodeField;
